import React from 'react';
import { NavLink } from 'react-router-dom';

const PlanExpiredPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <span className="text-6xl">🔒</span>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Tu periodo de prueba ha finalizado
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Esperamos que hayas disfrutado de Podoclinic. Para continuar accediendo a tus datos y gestionando tu clínica, por favor suscríbete a un plan.
          </p>
        </div>

        <div className="mt-8 bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="space-y-6">
            <div className="bg-orange-50 border-l-4 border-orange-400 p-4">
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg className="h-5 w-5 text-orange-400" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="ml-3">
                  <p className="text-sm text-orange-700">
                    El acceso a las funciones está restringido hasta que se active la suscripción.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <NavLink
                to="/app/suscripcion"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
              >
                Ver Planes y Suscribirse
              </NavLink>
            </div>
            
            <div className="text-center mt-4">
              <p className="text-xs text-gray-500">
                ¿Necesitas ayuda? <a href="mailto:soporte@podoclinic.cl" className="text-green-600 hover:text-green-500">Contáctanos</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanExpiredPage;
